import { spacing } from 'ui/theme';
import styled from 'styled-components';
import { FixedWidth } from 'ui/utility/fixedWidth';

export const MainContentFixedWidth = styled(FixedWidth)`
  & > div:not(:first-of-type) {
    margin-top: ${spacing.double};
  }
`;
